import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Workspace from 'src/entities/workspace';
import { getWorkspace } from 'src/selectors/workspaces';
import { getCurrentUserID } from 'src/selectors/currentUser';
import { fetchWorkspaceSettingsInformation } from 'src/actions/workspaces';

const useWorkspaceInformation = ( workspaceID: number ): Workspace => {
	const dispatch = useDispatch();

	// @ts-expect-error - TODO: fix this
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const workspace: Workspace = useSelector( ( state: any ) => getWorkspace( state, { workspaceID } ) );
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const currentUserID: number = useSelector( ( state: any ) => getCurrentUserID( state ) );

	useEffect( () => {
		if ( workspace ) {
			const isOwner = workspace.userIsOwner( currentUserID );
			dispatch( fetchWorkspaceSettingsInformation( workspace, isOwner ) );
		}
	}, [ workspace.id, currentUserID ] );

	return workspace;
};

export default useWorkspaceInformation;
